import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function OutcomeSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('aboutAcademy.outcome.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('aboutAcademy.outcome.title')}
          </h2>
          {String(t('aboutAcademy.outcome.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('aboutAcademy.outcome.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.04em] leading-[2] max-w-[760px] mx-auto text-left md:text-center">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="border border-accent-500/25 bg-primary-900/40 p-7 md:p-9">
              <h3 className="font-heading text-[19px] md:text-[21px] text-foreground-50 tracking-[0.05em] mb-5">
                {t('aboutAcademy.outcome.cert.title')}
              </h3>
              {String(t('aboutAcademy.outcome.cert.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.03em] leading-[2.05] mb-6">{__s}</p>))}
              <Link
                to="/certificate"
                className="inline-flex items-center gap-2 text-[15px] text-accent-400 hover:text-accent-300 tracking-[0.05em] transition-colors"
              >
                <span>{t('aboutAcademy.outcome.cert.link')}</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="relative mb-7">
              <div className="absolute -inset-2 border border-accent-500/20 pointer-events-none hidden md:block"></div>
              <img
                src="/images/generated/corporate-hero-2026.jpg"
                alt={t('aboutAcademy.outcome.corp.imgAlt')}
                className="relative w-full aspect-[16/9] object-cover object-center"
                loading="lazy"
              />
            </div>
            <h3 className="font-heading text-[19px] md:text-[21px] text-foreground-50 tracking-[0.05em] mb-5">
              {t('aboutAcademy.outcome.corp.title')}
            </h3>
            {String(t('aboutAcademy.outcome.corp.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.03em] leading-[2.05] mb-6">{__s}</p>))}
            <Link
              to="/corporate"
              className="inline-flex items-center gap-2 text-[15px] text-accent-400 hover:text-accent-300 tracking-[0.05em] transition-colors"
            >
              <span>{t('aboutAcademy.outcome.corp.link')}</span>
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
